export interface CheckboxColors {
  selectedBackground?: string | null;
  selectedBorder?: string | null;
}

export function buildCheckboxCssRules(
  s: string,
  colors: CheckboxColors | null | undefined,
): string[] {
  if (!colors) return [];

  const bg = colors.selectedBackground || undefined;
  const border = colors.selectedBorder || undefined;

  if (!bg && !border) return [];

  const selectors = [
    `${s}[data-ui="item-checkbox"]`,
    `${s}[data-ui="bundle-group-checkbox"]`,
    // Selection-card-like radio card surfaces reuse the same tokens for their
    // selected bubble state.
    `${s}[data-ui="option"]`,
    `${s}[data-selection-card]`,
  ];
  const selectorList = selectors.join(", ");

  const vars: string[] = [];
  if (bg) {
    vars.push(`--redo-colors-background-bg-alternate: ${bg};`);
    vars.push(`--redo-colors-background-bg-secondary-solid: ${bg};`);
    vars.push(`--redo-colors-text-text-secondary_hover: ${bg};`);
  }
  if (border) {
    vars.push(`--redo-colors-border-border-primary: ${border};`);
    // The border color also controls the checkmark icon color
    vars.push(`--redo-colors-foreground-fg-on-brand: ${border};`);
  }

  const selectionCardColorsRule = `${selectorList} { ${vars.join(" ")} }`;

  return [selectionCardColorsRule];
}
